/** Where an asset without its own GPS unit stands now, worked out from its events. */
export interface AssetState {
  lat?: number;
  lon?: number;
  customerId?: string;
  customerSince?: string;
  lastEventAt?: string;
  lastEventTypeKey?: string;
  lastServiceAt?: string;
}

export interface ScanAsset {
  /** What the NFC tag or QR code carries, e.g. "FF-A:00042". */
  tag: string;
  /** Serial number of the NFC tag, so a copied tag content shows up. */
  nfcSerial?: string;
  name: string;
  assetType: string;
  serviceDays?: number;
  groupIds?: string[];
  /** A cache of the history; `recomputeAssetState` rebuilds it. */
  state?: AssetState;
}

export interface ScanCustomer {
  customerId: string;
  name: string;
  odooRef?: string;
  city?: string;
}

export type CustomerEffect = "none" | "set" | "release";

export interface ScanEventType {
  key: string;
  name: string;
  changesLocation: boolean;
  customerEffect: CustomerEffect;
  countsAsService: boolean;
  noteRequired: boolean;
  active: boolean;
  builtIn: boolean;
}

export type ScanVia = "NFC" | "QR" | "manual";

export interface ScanEvent {
  asset: string;
  eventTypeKey: string;
  /** Kept with the event so the history stays readable after the type is renamed or removed. */
  eventTypeName: string;
  time: string;
  lat?: number;
  lon?: number;
  accuracy?: number;
  user: string;
  via: ScanVia;
  customerId?: string;
  note?: string;
}

/** An AddInData row: its Geotab id and what we stored. */
export interface Stored<T> {
  id: string;
  details: T;
}

/** The map and the customer periods rely on these two; they can be renamed, not removed. */
export const BUILT_IN_EVENT_TYPES: ScanEventType[] = [
  {
    key: "deploy",
    name: "Aufstellen",
    changesLocation: true,
    customerEffect: "set",
    countsAsService: false,
    noteRequired: false,
    active: true,
    builtIn: true,
  },
  {
    key: "pickup",
    name: "Abholen",
    changesLocation: true,
    customerEffect: "release",
    countsAsService: false,
    noteRequired: false,
    active: true,
    builtIn: true,
  },
];
